import { Component, EventEmitter, Inject, OnInit, Optional, Output, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tierliste } from '../../gruppe-tier/classes/tierliste';
import { GruppeAbgangDialogInput } from './gruppe-abgang-dialog';
import { AbgangListeComponent } from '../gruppe-abgang/abgang-liste/abgang-liste.component';
import {
    LISTE_ABSCHLIESSEN_STEPPER_HANDLER,
    ListeAbschliessenStepperHandler,
} from '../gruppe-abgang/liste-abschliessen-stepper.handler';

@Component({
    selector: 'kiene-gruppe-abgang-dialog',
    templateUrl: './gruppe-abgang-dialog.component.html',
    styleUrls: ['./gruppe-abgang-dialog.component.scss'],
})
export class GruppeAbgangDialogComponent implements OnInit, AfterViewInit {
    @Output('geschlossen') geschlossen = new EventEmitter<Tierliste>();
    @ViewChild('gruppeAbgang') gruppeAbgangComponent: any;

    public anzahlTiereInListe: number = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: GruppeAbgangDialogInput,
        public dialogRef: MatDialogRef<GruppeAbgangDialogComponent>,
        @Optional()
        @Inject(LISTE_ABSCHLIESSEN_STEPPER_HANDLER)
        private readonly listeAbschliessenStepperHandler?: ListeAbschliessenStepperHandler,
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {}

    abgangGeschlossen(event: Tierliste) {
        if (event) {
            this.geschlossen.emit(event);
            this.dialogRef.close(event);
        }
    }

    public close(): void {
        this.dialogRef.close();
    }

    public scansFortsetzen(): void {
        const tierliste = this.data?.tierliste ?? this.gruppeAbgangComponent?.tierliste;
        if (this.listeAbschliessenStepperHandler && tierliste?.tierliste_id) {
            this.dialogRef.close(false);
            this.listeAbschliessenStepperHandler.open(tierliste).subscribe({
                next: saved => {
                    if (saved) {
                        this.geschlossen.emit(tierliste);
                    }
                },
            });
            return;
        }
        if (this.gruppeAbgangComponent) {
            this.gruppeAbgangComponent.triggerScansFortsetzen();
        }
    }

    public hasTiereInListe(): boolean {
        return this.anzahlTiereInListe > 0;
    }

    public onTiereAnzahlChanged(anzahl: number): void {
        this.anzahlTiereInListe = anzahl;
    }

    public onScansFortsetzen(): void {
        this.scansFortsetzen();
    }
}
